// src/slices/mapSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGeoJSON } from "../api/kentyouEye";

// Thunk to fetch ALL pages of GeoJSON
export const fetchAllGeoJSON = createAsyncThunk(
  "map/fetchAll",
  async (_, { rejectWithValue }) => {
    let allFeatures = [];
    let token = "";
    try {
      do {
        const json = await getGeoJSON(50, token);
        // JSON shape: { data: { type, features: [...], ... }, pagination: { continuationToken, ... } }
        const page = json.data;
        allFeatures = allFeatures.concat(page.features);
        token = json.pagination.token || "";
      } while (token);
      return allFeatures;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const mapSlice = createSlice({
  name: "map",
  initialState: {
    features: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearMap(state) {
      state.features = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllGeoJSON.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllGeoJSON.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.features = action.payload; // array of GeoJSON features
      })
      .addCase(fetchAllGeoJSON.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearMap } = mapSlice.actions;
export default mapSlice.reducer;
